<template>
    <div>
        <template v-if="getLoadedPdf">
            <div class="notification-note">
                <p>
                    <span> Evaluación terminada: {{ msgNotification }} </span>
                </p>
            </div>
        </template>
        <template>
            <div
                class="vertical-polls col-2"
                id="vertical-surveys"
                style="height: 100%"
                v-if="openSwipe"
            >
                <v-row class="vertical-polls-container">
                    <v-col cols="12" >
                        <v-row no-gutters>
                            <v-col cols="12" class="mb-2 text-center">
                                <h3 v-if="isNote">Nota: {{ points }}</h3>
                                <h3 v-if="isPercentage">
                                    Logro:
                                    {{ calculatePercentage(percentage) }}%
                                </h3>
                            </v-col>
                            <v-col cols="8" v-if="showAnswers">
                                <h4>Correctas:</h4>
                                <h4>Incorrectas:</h4>
                                <h4>Omitidas:</h4>
                            </v-col>
                            <v-col cols="4" class="float-left" v-if="showAnswers">
                                <h4>{{ corrects }}</h4>
                                <h4>{{ incorrects }}</h4>
                                <h4>{{ skippeds }}</h4>
                            </v-col>
                        </v-row>
                    </v-col>


                    <div v-if="showAnswers">
                        <v-col 
                        v-if="(attachFiles || enterText)"
                        class="d-flex justify-center align-center "
                        style="width: 100%"
                        cols="auto">
                            <div justify="center">
                                <v-dialog
                                class="dialog"
                                v-model="dialogRubrica"
                                persistent
                                max-width="290"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                    
                                        <v-btn
                                            class="btn-text-file"
                                            outlined
                                            rounded
                                            color="white"
                                            dark
                                            v-bind="attrs"
                                            v-on="on"
                                            
                                        >
                                            <v-icon
                                                class="text-center"
                                                >
                                                mdi-arrow-up-bold-box-outline
                                            </v-icon>
                                        </v-btn>
                                    </template>
                                    <v-card class="d-inline-block">
                                        <v-card-title class="text-h5">
                                        Texto / Archivos
                                        </v-card-title>
                                        <v-card-text>
                                                <quillEditor
                                                v-if="enterText"
                                                class="lesson-detail__quill"
                                                :content="textRubrica"
                                                :options="editorOptionByQuestion"
                                                :disabled="true"
                                                @change="onEditorChange($event)"

                                                />
                                                <v-file-input
                                                    disabled
                                                    v-if="attachFiles"
                                                    v-model="files"
                                                    placeholder="Subir archivos"
                                                    label="Archivos"
                                                    multiple
                                                    prepend-icon="mdi-paperclip"
                                                    small-chips
                                                    truncate-length="15"
                                                    
                                                >
                                                    <template v-slot:selection="{ text }">
                                                    <v-chip
                                                        small
                                                        label
                                                        color="primary"
                                                    >
                                                        {{ text }}
                                                    </v-chip>
                                                    </template>
                                                </v-file-input>
                                        </v-card-text>
                                        <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="primary"
                                            text
                                            @click="dialogRubrica = false"
                                        >
                                            <span class="text-center text-capitalize"
                                            >Minimizar</span>
                                        </v-btn>
                                        </v-card-actions>
                                    </v-card>
                                </v-dialog>
                            </div>
                        </v-col>

                        <v-col
                            cols="12"
                            v-for="(item, i) in questions"
                            :key="i + 1"
                        >
                            <div v-if="item.options && item.options.length > 0">
                                <v-row align-content="center">
                                <v-col cols="2" class="option">
                                    <span class="question">
                                        {{ i + 1 }}
                                    </span>
                                </v-col>
                                <v-col cols="2" class="option valid">
                                    <span>
                                        {{ item.correct }}
                                    </span>
                                </v-col>
                                <v-col cols="2" class="option" :class="item.class">
                                    <span>
                                        {{ item.answered }}
                                    </span>
                                </v-col>
                                <v-col cols="2" class="option">
                                    <span>
                                        <v-icon
                                            class="icon-indicator"
                                            :color="item.color"
                                            >{{ item.icon }}</v-icon
                                        >
                                    </span>
                                </v-col>
                                </v-row>
                            </div>

                            <div v-else class="d-flex">
                                <div  class="option d-flex justify-center align-center">
                                    <span class="question">
                                        {{ i + 1 }}
                                    </span>
                                </div>


                                <div>
                                        <div class="d-none">
                                        {{reactive}}
                                        </div>

                                                    <div class="d-flex align-center justify-center ">
                                                        <v-btn
                                                        color="primary"
                                                        rounded
                                                        @click.stop="item.dialogQuestion = true"
                                                        @click="openDialogQuestion(item.dialogQuestion)"
                                                        >
                                                            <span class="text-center text-capitalize"
                                                            >Respuesta</span>
                                                        </v-btn>
                                                    </div>
                                                    

                                                    <v-dialog
                                                    class="dialog"
                                                    v-model="item.dialogQuestion"
                                                    persistent
                                                    max-width="290"
                                                    >
                                                        <v-card class="d-inline-block">
                                                            <v-card-title class="text-h5">
                                                            Pregunta  {{ i + 1 }}
                                                            </v-card-title>
                                                            <v-card-text>
                                                                    <quillEditor
                                                                    v-if="item.enterText"
                                                                    class="lesson-detail__quill"
                                                                    :content="item.text"
                                                                    :options="editorOptionByQuestion"
                                                                    :disabled="true"
                                                                    />
                                                                    <v-file-input
                                                                        disabled
                                                                        v-if="item.attachFiles"
                                                                        v-model="item.files"
                                                                        placeholder="Subir archivos"
                                                                        label="Archivos"
                                                                        multiple
                                                                        prepend-icon="mdi-paperclip"
                                                                        small-chips
                                                                        truncate-length="15"
                                                                        
                                                                    >
                                                                        <template v-slot:selection="{ text }">
                                                                        <v-chip
                                                                            small
                                                                            label
                                                                            color="primary"
                                                                        >
                                                                            {{ text }}
                                                                        </v-chip>
                                                                        </template>
                                                                    </v-file-input>
                                                            </v-card-text>
                                                            <v-card-actions>
                                                            <v-spacer></v-spacer>
                                                            
                                                            <v-btn
                                                                color="primary"
                                                                text
                                                                @click.stop="item.dialogQuestion = false"
                                                                @click="closesDialogQuestion(item.dialogQuestion)"

                                                            >
                                                            <span class="text-center text-capitalize"
                                                            >Minimizar</span>
                                                                
                                                            </v-btn>
                                                            </v-card-actions>
                                                        </v-card>
                                                    </v-dialog>
                                </div>
                            </div> 

                        </v-col>
                    </div>
                    
                </v-row>
            </div>
            <v-btn
                v-if="getLoadedPdf"
                class="open-swipe"
                :class="openSwipe ? 'open-btn' : 'close-btn'"
                @click="swipe()"
                icon
            >
                <v-icon v-if="openSwipe" color="black" class="icon-open-close"
                    >mdi-chevron-right</v-icon
                >
                <v-icon v-else color="white" class="icon-open-close"
                    >mdi-chevron-left</v-icon
                >
            </v-btn>
            <RomaPdfBtnZoom v-if="!getIsPreBasicAndLinkEmbebed && getLoadedPdf" />
        </template>
    </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import RomaPdfBtnZoom from "../commons/RomaPdfBtnZoom.vue";

import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

import { quillEditor } from "vue-quill-editor";
export default {
    name: "RomaEvaluationMobileResults",
    data() {
        return {
            dialogRubrica : false,
            files: [],
            textRubrica: '',
            attachFiles:false,
            enterText:false,
            reactive:false,

            editorOption: {
                readOnly: false,
                modules: {
                    toolbar: [
                            ]
                },
                placeholder: ''
            },
            editorOptionByQuestion: {
                readOnly: true,
                modules: {
                    toolbar: [
                            ]
                       
                },
                placeholder: ''
            },

            openSwipe: true,
            questions: [],
            isNote: false,
            isPercentage: false,
            isAverage: false,
            msgNotification: null,
            showAnswers: false
        };
    },
    components: {
        RomaPdfBtnZoom,
        quillEditor
    },
    computed: {
        ...mapGetters({
            getLoadedPdf: "getLoadedPdf",
            getResults: "getResults",
            getOpenSurveys: "getOpenSurveys",
            getIsPreBasicAndLinkEmbebed: "getIsPreBasicAndLinkEmbebed",

            getEvaluationDetail: "getEvaluationDetail",
            getCurrentAnswers: "getCurrentAnswers",
            getCurrentTextFormaAsignada:"getCurrentTextFormaAsignada",
            getCurrentFilesFormaAsignada:"getCurrentFilesFormaAsignada",
            getCurrentTextAnswers:"getCurrentTextAnswers",
            getCurrentFilesAnswers:"getCurrentFilesAnswers",
        }),
        answers() {
            return this.getResults.answers;
        },
        corrects() {
            return this.getResults.correctas;
        },
        incorrects() {
            return this.getResults.incorrectas;
        },
        skippeds() {
            return this.getResults.omitidas;
        },
        points() {
            return this.getResults.puntajeEstandar;
        },
        percentage() {
            return this.getResults.porcentajePonderadologro;
        }
    },
    mounted() {
        if (this.getLoadedPdf) {
            switch (this.getResults.enviarNota) {
                case "ENVIAR_NOTA_LOGRO":
                    this.isNote = true;
                    this.isPercentage = true;
                    this.msgNotification = `Nota ${this.points}`;
                    break;
                case "ENVIAR_NOTA":
                    this.isNote = true;
                    this.msgNotification = `Nota ${this.points}`;
                    break;
                case "ENVIAR_LOGRO":
                    this.isPercentage = true;
                    this.msgNotification = `Logro ${this.calculatePercentage(
                        this.percentage
                    )}`;
                    break;
            }
        }
        this.showAnswers = this.getResults.mostrarRespuestas;
        const list = [];
        const optionLetters = ["A", "B", "C", "D", "E", "F"];
        this.answers.forEach(row => {
            if (row.letraRespuesta !== "") {
                if (row.letraRespuesta === row.letraRespuestaCorrecta) {
                    
                    const options = [];
                    let correct = null;
                    let mode = null;
                    let styleClass = null;
                    for (let i = 0; i < row.nroAlternativas; i++) {
                        if (row.letraRespuesta === optionLetters[i]) {
                            correct = optionLetters[i];
                            mode = "correct";
                            if (!this.getIsPreBasicAndLinkEmbebed) {
                                styleClass = "correct";
                            }else{
                                styleClass = "correct"+optionLetters[i];
                            }
                        } else {
                            mode = "empty";
                            styleClass = "empty";
                        }
                        options.push({
                            letter: optionLetters[i],
                            correct: correct,
                            mode: mode,
                            class: styleClass
                        });
                    }
                                        
                    list.push({
                        nroPregunta: row.nroPregunta,
                        nroAlternativas: row.nroAlternativas,
                        mode: "CORRECT",
                        answered:
                            row.letraRespuesta !== ""
                                ? row.letraRespuesta
                                : null,
                        correct: row.letraRespuestaCorrecta,
                        class: "container-correct",
                        icon: "mdi-check",
                        color: "correct",
                        options: options

                    });

                                        
                } else {
                    const options = [];
                    let correct = null;
                    let incorrect = null;
                    let mode = null;
                    let styleClass = null;
                    for (let i = 0; i < row.nroAlternativas; i++) {
                        if (row.letraRespuestaCorrecta === optionLetters[i]) {
                            correct = optionLetters[i];
                            mode = "correct";
                            styleClass = "correct-inverted";
                        } else if (row.letraRespuesta === optionLetters[i]) {
                            incorrect = optionLetters[i];
                            mode = "incorrect";
                            if (!this.getIsPreBasicAndLinkEmbebed) {
                                styleClass = "incorrect";
                            }else{
                                styleClass = "incorrect"+optionLetters[i];
                            }
                        } else {
                            mode = "empty";
                            styleClass = "empty";
                        }
                        options.push({
                            letter: optionLetters[i],
                            correct: correct,
                            incorrect: incorrect,
                            mode: mode,
                            class: styleClass
                        });

                    }


                    list.push({
                        nroPregunta: row.nroPregunta,
                        nroAlternativas: row.nroAlternativas,
                        mode: "INCORRECT",
                        answered:
                            row.letraRespuesta !== ""
                                ? row.letraRespuesta
                                : null,
                        correct: row.letraRespuestaCorrecta,
                        class: "container-incorrect",
                        icon: "mdi-close",
                        color: "incorrect",
                        options: options
                    });
                }
            } else {
                const options = [];
                let correct = null;
                let mode = null;
                let styleClass = null;
                for (let i = 0; i < row.nroAlternativas; i++) {
                    if (row.letraRespuestaCorrecta === optionLetters[i]) {
                        correct = optionLetters[i];
                        mode = "skipped";
                        styleClass = "skipped";
                    } else {
                        mode = "empty";
                        styleClass = "empty";
                    }

                    options.push({
                        letter: optionLetters[i],
                        correct: correct,
                        mode: mode,
                        class: styleClass
                    });
                }
                list.push({
                    nroPregunta: row.nroPregunta,
                    nroAlternativas: row.nroAlternativas,
                    mode: "SKIPPED",
                    answered: "-",
                    correct: row.letraRespuestaCorrecta,
                    class: "container-skipped",
                    icon: "mdi-checkbox-blank-circle-outline",
                    color: "skipped",
                    options: options
                });
            }
        });
        this.questions = list;


       const { attachFiles ,enterText } = this.getEvaluationDetail.medicionAsignadaTO.medicionTO;
        this.attachFiles = attachFiles;
        this.enterText = enterText;
        if (enterText) {
            this.textRubrica = this.getCurrentTextFormaAsignada[3];
        }
        if (attachFiles) {
            for (let i = 0; i < this.getCurrentFilesFormaAsignada.length; i++) {
                const f = new File([""], this.getCurrentFilesFormaAsignada[i][4], { type: 'text/html' });
                this.files.push(f);
            }
        }

        this.getEvaluationDetail.form.questions.forEach(a => {
            this.questions.forEach(answer => {
                if (a.nroQuestion == answer.nroPregunta) {
                    answer.attachFiles =  a.attachFiles
                    answer.enterText = a.enterText
                };
            })
        });


        if (this.questions !== null && this.getCurrentAnswers !== null) {
            this.questions.forEach(answer => {
                answer['files'] = []
                answer['dialogQuestion'] = false;

                if (this.getCurrentAnswers.length !== 0) {

                    this.getCurrentAnswers.forEach(currentAnswer => {
                        
                        if (
                            answer.nroPregunta === currentAnswer.nroPregunta
                        ) {
                            // answer.answerLetter = currentAnswer.letraRespuesta;

                            // RUBRICA
                            answer['text'] = currentAnswer.textoRespuesta;
                            if (currentAnswer.fileRespuesta && currentAnswer.fileRespuesta.length > 0) {
                                for (let i = 0; i < currentAnswer.fileRespuesta.length; i++) {
                                    answer.files.push(currentAnswer.fileRespuesta[i])
                                }
                            }
                            if (answer.enterText  || answer.attachFiles) {
                                
                                answer['class'] = "container-rubrica";

                            }


                        }
                    });
                // } else {
                //     answer.answerLetter = "";

                }
            });
            // this.setAnswers({ answers: this.answers });
        }
    },
    methods: {
        ...mapActions({
            setOpenSurveys: "setOpenSurveys",
            toastTimeCount: "toastTimeCount"
        }),
        swipe() {
            if (this.openSwipe) {
                this.setOpenSurveys({ openSurveys: false });
            } else {
                this.setOpenSurveys({ openSurveys: true });
            }
            this.openSwipe = !this.openSwipe;
        },
        calculatePercentage(p) {
            const s = p.toString();
            const sp = s.split(".");
            if (sp.length >= 2) {
                return p.toFixed(1);
            }
            return p;
        },
        openDialogQuestion(question){
            this.reactive = true;
        },
        closesDialogQuestion(question){
            this.reactive = false;
        },
    }
};
</script>

<style lang="scss" scoped>
@import "../../assets/styles/numbers.css";

.notification-note {
    z-index: 9999 !important;
    width: 100% !important;
    background-color: #fff !important;
    box-shadow: 0 11px 24px rgba(0, 0, 0, 0.16);
    color: #804088 !important;
    top: 58px;
    position: fixed;
    left: 0;
    text-align: center;
    padding: 7px;
}

h3,
h4 {
    font-family: "Cabin", Regular, sans-serif !important;
}

.option {
    border-radius: 5px;
    margin: 5px;
    text-align: center;
    height: 28px;
    width: 26px;
    line-height: 4px;
    padding-right: 19px;
}

.valid {
    background: #ffffff;
    color: #3a8fce;
}

.question {
    font-weight: bold;
    font-size: 1.2em;
}

.open-swipe {
    position: fixed;
    right: -14px;
    z-index: 99999;
    top: 50vh;
    background: #ffffff;
    opacity: 0.8;
    i {
        color: #ffffff;
    }
}
.open-btn {
    background: #ffffff;
}
.close-btn {
    background: #000000;
}

.icon-open-close {
    padding-right: 12px;
}

.icon-indicator {
    bottom: 10px !important;
    right: 15px;
}

#vertical-surveys {
    position: fixed;
    top: 0;
    bottom: 0;
    width: 180px;
    max-width: 180px;
    background: #000000;
    opacity: 0.9;
    z-index: 9999;
    color: #ffffff;
    padding-bottom: 110px;
    margin-bottom: 90px;
    overflow-y: scroll;
    right: -12px;
}

.vertical-polls {
    .vertical-polls-container {
        /*overflow-y: scroll;*/
        padding-top: 2px;
        padding-bottom: 150px !important;
    }
}

.icon-letter {
    padding-bottom: 3px;
    padding-left: 1px;
    background: transparent !important;
}

.letter-white-a:before {
    content: url("../../assets/images/letter/a.svg");
}

.letter-white-b:before {
    content: url("../../assets/images/letter/b.svg");
}

.letter-white-c:before {
    content: url("../../assets/images/letter/c.svg");
}

.letter-white-d:before {
    content: url("../../assets/images/letter/d.svg");
}

.letter-white-e:before {
    content: url("../../assets/images/letter/e.svg");
}

.container-incorrect {
    background: #ff5757;
    i {
        color: #ffffff;
    }
}
.container-correct {
    background: #3a8fce;
    i {
        color: #ffffff;
    }
}
.container-skipped {
    background: #181818;
    i {
        color: #ffffff;
    }
}

@media (max-width: 599px) {
    .button-option {
        padding-left: 6%;
    }
    .btn--roma {
        padding: 5px 20px !important;
    }

    .v-dialog .v-card.v-sheet.theme--light .answered-wrapper {
        padding: 25px !important;
    }
}

.group-btn-zoom {
    position: fixed;
    top: 85vh !important;
}

.open-surveys {
    right: 180px !important;
}
.close-surveys {
    right: 30px !important;
}
</style>
